export class CalcEngineConstants {
  public static readonly PRIMARY_KEY = 'primaryKey';
}

export class CalcEngineRequest {
  public applicationId: number;
  public stringMap: {} = {};
  public intMap: {} = {};
  public objectMap: {} = {};
  public stringListMap: {} = {};
  public intListMap: {} = {};
  public objectListMap: {} = {};
  public groupBy: string[] = [];
  public additionalFields: { [key: string]: string[] } = {};  // Maps datasetId to list of fieldIds
  public filters: any = {};
  public metricList: Metric[] = [];

  constructor() {
  }
}

export class Metric {
  public metricName: string;
  public metricId: number;
}

export class CalcEngineResponse {
  public status: CalcEngineCodes;
  public message: string;
  public rowData: any[]; // Changed from object to array of row objects
  public columnDef: ColumnDef[];
}

export class ColumnDef {
  public field: string;
  public type: string;
}

export enum CalcEngineCodes{
  SUCCESS = 20000,
  BAD_REQUEST = 40000,
  INTERNAL_ERROR = 50000
}
